import styled from 'styled-components'

export const Content = styled.div`
  display: grid;
  width: 100%;
  column-gap: 1rem;
  grid-template-columns: 20% calc(80% - 1rem);
  row-gap: 2rem;
  height: 100%;
  overflow: hidden;
`

export const LeftSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 100%;
  overflow-y: auto;
  padding-right: 0.5rem;
`
export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: #FFF;
  height: fit-content;
  border-radius: 1rem;
  padding: 1.2rem 1rem;
`

export const StructureHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
`

export const StructureHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  position: relative;
`

export const ConformityStatus = styled.div<{outOfNorm?: boolean}>`
  ${props => props.outOfNorm ? `
    background-color: #FFFCEE;
    color: #9D7D07;
  ` : `
    color: #67C97E;
    background-color:rgba(179, 228, 191, 0.3);
  `}
  padding: .5rem 1rem;
  border-radius: 2rem;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: .5rem;
  font-weight: 400;
  user-select: none;
`

export const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
`

export const AllowFilesDiv = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  width: fit-content;
`
 
export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
  height: 100%;
  padding-right: 0.5rem;
`

export const ParamMainFieldsContainer = styled.div`
  background-color: #FFF;
  border-radius: 1rem;
  padding: 1.2rem 1rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1rem;
  row-gap: 1rem;
  height: fit-content;
`

export const InputDiv = styled.div`
  height: fit-content;
  &.itemParent{
    display: flex;
    gap: .5rem;
  }
`

export const Label = styled.label`
  font-size: 14px;
  font-weight: 700;
  display: block;
  margin-bottom: 0.5rem;
`

export const Input = styled.input`
  width: 100%;
  height: 40px;
  background-color: #EBEBEB;
  border: 0;
  border-radius: 2rem;
  padding: 1rem;
  outline: none;
`

export const StructureContainer = styled.div`
  background-color: #FFF;
  padding: 1.2rem 2rem;
  border-radius: 1rem;
`

export const StructuresListContainer = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  margin: 0;
  gap: 5px;
`

export const StructureListItem = styled.li<{last?: boolean}>`
  padding: .8rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  ${props => props.last ? `
    border-bottom: none;
    padding-bottom: 0;`
  : 
    'border-bottom: 1px solid #EBEBEB;'};

  span{
    cursor: pointer;
    user-select: none;
    color: #0090D3;
    width: 2rem;
    text-align: center;
  }
`

export const ButtonDiv = styled.div`
  display: flex;
  grid-row: 2;
  grid-column: 2;
  justify-content: end;
  height: fit-content;
  align-items: end;
  gap: 1rem;
`

export const Button = styled.button<{isSave?:boolean}>`
  color: ${props => !props.isSave ? '#0090D3' : '#FFF'};
  font-size: 14px;
  border: 1px solid #0090D3;
  background-color: ${props => props.isSave ? '#0090D3' : '#FFF'};
  outline: none;
  display: flex;
  gap: .7rem;
  padding: .8rem 1rem;
  cursor: pointer;
  border-radius: 1.5rem;
  font-weight: 700;
  align-items: center;
  height: fit-content;
`

export const HeaderFieldsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
`